import { render, staticRenderFns } from "./cardFaqUpload.vue?vue&type=template&id=0b8f3c17"
import script from "./cardFaqUpload.vue?vue&type=script&lang=js"
export * from "./cardFaqUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports